import { CURRENCIES, DATE_FORMATS, LANGUAGES, type UpdateOrganizationInput } from '@chukua/common';
import { Form, Input, Select } from 'antd';

const LANGUAGE_LABELS: Record<(typeof LANGUAGES)[number], string> = { en: 'English', sw: 'Swahili' };

export interface CompanySettingsFormValues {
  name: string;
  legalName?: string;
  kraPin?: string;
  address?: string;
  currency: UpdateOrganizationInput['currency'];
  timezone: string;
  dateFormat: UpdateOrganizationInput['dateFormat'];
  language: UpdateOrganizationInput['language'];
}

/** The fields themselves, split out so CompanySettingsForm stays focused on the form's wiring. */
export function CompanySettingsFields() {
  return (
    <>
      <Form.Item name="name" label="Company name" rules={[{ required: true, message: 'Enter a company name' }]}>
        <Input autoFocus />
      </Form.Item>
      <Form.Item name="legalName" label="Legal name">
        <Input />
      </Form.Item>
      <Form.Item name="kraPin" label="KRA PIN">
        <Input />
      </Form.Item>
      <Form.Item name="address" label="Address">
        <Input.TextArea rows={3} />
      </Form.Item>
      <Form.Item name="currency" label="Reporting currency" rules={[{ required: true }]}>
        <Select options={CURRENCIES.map((currency) => ({ value: currency, label: currency }))} />
      </Form.Item>
      <Form.Item name="timezone" label="Timezone" rules={[{ required: true, message: 'Enter a timezone' }]}>
        <Input placeholder="Africa/Nairobi" />
      </Form.Item>
      <Form.Item name="dateFormat" label="Date format" rules={[{ required: true }]}>
        <Select options={DATE_FORMATS.map((dateFormat) => ({ value: dateFormat, label: dateFormat }))} />
      </Form.Item>
      <Form.Item name="language" label="Default language" rules={[{ required: true }]}>
        <Select options={LANGUAGES.map((language) => ({ value: language, label: LANGUAGE_LABELS[language] }))} />
      </Form.Item>
    </>
  );
}
